/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

export default freeGlobal;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash-es/_freeGlobal.js
// module id = 947
// module chunks = 2 3 6 9 13